import type { InvoiceOverview } from '@vy/api-definition';
import { INVOICE_REVIEW_STATUSES, SYNC_STATUSES } from '@vy/types';

export function useFilteredSyncSelectedInvoices(selectedInvoices: InvoiceOverview[]): InvoiceOverview[] {
  return selectedInvoices.filter(
    (invoice) =>
      invoice.reviewStatus === INVOICE_REVIEW_STATUSES.Approved &&
      invoice.syncStatus !== SYNC_STATUSES.Synced,
  );
}
